<div id="toggler" class="d-flex py-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    @for (column of tableModel.options.columns; track column) {
        <div class="col">
            <span> {{ get(rowData, column.field) }}</span>
        </div>
    }
</div>
@if (!isCollapsed) {
    <div class="row align-items-center py-3" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        @if (!softwareLicencesDisplayed) {
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="equipmentNo"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_EQUIPMENT_ID"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="equipmentNo">{{ rowData ? rowData.equnr.value : '' }}</span>
            </div>
            <label class="col-6 col-sm-2 col-form-label text-center" for="ksNo">{{
                technicalIdOrFunctionalLocationLabel
            }}</label>
            <div class="col-6 col-sm-3">
                <span class="user-select-auto" id="ksNo">{{ rowData ? rowData.tidnr.value : '' }}</span>
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="materialNo"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_MATERIAL_ID"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="materialNo">{{ rowData ? rowData.matnr.value : '' }}</span>
            </div>
            <label
                class="col-6 col-sm-2 col-form-label text-center"
                for="warranty"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_WARRANTY"
            ></label>
            <div class="col-6 col-sm-3">
                @if (rowData && rowData.warrantyEndDate.value.isValid()) {
                    <span class="user-select-auto" id="warranty">
                        {{ rowData.warrantyEndDate.formattedDisplayedDate }}
                    </span>
                }
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="serialNo"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_SERIAL_NO"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="serialNo">{{ rowData ? rowData.sernr.value : '' }}</span>
            </div>
            @if (displayContractField) {
                <label
                    class="col-6 col-sm-2 col-form-label text-center"
                    for="contract"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_CONTRACT"
                ></label>
                <div class="col-6 col-sm-3">
                    <span class="user-select-auto" id="contract">{{ rowData ? rowData.contractType.value : '' }}</span>
                </div>
            }
            <!-- Cust. Ref. field -->
            @if (displayMaparField) {
                <label
                    class="col-6 col-sm-3 col-form-label text-center align-self-start"
                    for="kenn"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_MAPAR"
                ></label>
                <div class="col-6 col-sm-2">
                    <span class="user-select-auto" id="kenn">{{ rowData ? rowData.mapar.value : '' }}</span>
                </div>
            }
            <label
                class="col-6 col-sm-2 col-form-label text-center align-self-start"
                for="serviceKey"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_SERVICE_KEY"
            ></label>
            <div class="col-6 col-sm-4 pt-2">
                @if (formatServiceKey(rowData?.serviceKey?.value); as formatted) {
                    <span class="user-select-auto text-wrap text-break d-block" id="serviceKey">
                        {{ formatted.primaryText }}
                        @if (formatted.emphasizedText) {
                            <b>
                                {{ formatted.emphasizedText }}
                            </b>
                        }
                    </span>
                }
                @if (tableModel.isTruncated) {
                    <fa-icon [icon]="faKey" (click)="showServiceKey()"></fa-icon>
                }
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="softwareVers"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_SOFTWARE_VERSION"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="softwareVers">{{ rowData ? rowData.softwareVers.value : '' }}</span>
            </div>
            <label
                class="col-6 col-sm-2 col-form-label text-center"
                for="deliveryDate"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_END_OF_DELIVERYDATE"
            ></label>
            <div class="col-6 col-sm-3">
                @if (rowData && rowData.endOfDeliveryDate.value.isValid()) {
                    <span class="user-select-auto" id="deliveryDate">
                        {{ rowData.endOfDeliveryDate.formattedDisplayedDate }}
                    </span>
                }
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="supportDate"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_END_OF_SUPPORTDATE"
            ></label>
            <div class="col-6 col-sm-2">
                @if (rowData && rowData.endOfSupportDate.value.isValid()) {
                    <span class="user-select-auto" id="supportDate">
                        {{ rowData.endOfSupportDate.formattedDisplayedDate }}
                    </span>
                }
            </div>
        }
        @if (softwareLicencesDisplayed) {
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="srlNo"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_SERIAL_NO"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="srlNo">{{ rowData ? rowData.serialNumber : '' }}</span>
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="matNo"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_MATERIAL_ID"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="matNo">{{ rowData ? rowData.materialNumber : '' }}</span>
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="startLicenceDate"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_START_DATE"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="startLicenceDate">{{
                    rowData && rowData.startDate.isValid() ? rowData.startDate.formattedDisplayedDate : ''
                }}</span>
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="endLicenceDate"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_END_DATE"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="endLicenceDate">{{
                    rowData && rowData.endDate.isValid() ? rowData.endDate.formattedDisplayedDate : ''
                }}</span>
            </div>
            <label
                class="col-6 col-sm-3 col-form-label text-center"
                for="status"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_STATUS"
            ></label>
            <div class="col-6 col-sm-2">
                <span class="user-select-auto" id="status">{{ rowData ? rowData.status : '' }}</span>
            </div>
        }
        <div class="d-flex justify-content-end">
            @if (!softwareLicencesDisplayed && rowData.serviceKey.value.length > 0) {
                <button
                    class="btn btn-primary"
                    type="button"
                    (click)="openServiceKey()"
                    [disabled]="!rowData"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_GET_SERVICE_KEY"
                ></button>
            }
        </div>
    </div>
}
